import React from "react";
import { useNavigate } from "react-router-dom";
import AdminPageLayout from "../components/AdminPageLayout";
import "../components/AdminPageLayout.css";
import "../styles/content.css";

const CONTENT_ITEMS = [
  { label: "Vocabulary",           desc: "Words, meanings & examples",                  path: "/admin/content/vocabulary",          icon: "📖" },
  { label: "Vocabulary Groups",    desc: "Curated vocabulary collections",               path: "/admin/content/vocabulary-groups",   icon: "📚" },
  { label: "Grammar",              desc: "Topics, rules & sub-topics",                   path: "/admin/content/grammar",             icon: "✏️" },
  { label: "Tongue Twisters",      desc: "Speaking practice content",                    path: "/admin/content/tongue",              icon: "👅" },
  { label: "Quick Boost",          desc: "Short video lessons",                          path: "/admin/content/quick-boost",         icon: "⚡" },
  { label: "Daily Sentences",      desc: "Everyday English sentences",                   path: "/admin/content/daily-sentences",     icon: "📅" },
  { label: "Official Sentences",   desc: "Professional & formal sentences",              path: "/admin/content/official-sentences",  icon: "🏢" },
  { label: "Similar Words",        desc: "Confusing words & homophones",                 path: "/admin/content/similar-words",       icon: "🔀" },
  { label: "IPA Symbols",          desc: "Phonetic symbol library",                      path: "/admin/content/ipa-symbols",         icon: "🔤" },
  { label: "IPA Lessons",          desc: "Pronunciation lessons",                        path: "/admin/content/ipa-lessons",         icon: "🎙️" },
  { label: "Phrases & Idioms",     desc: "Phrases, idioms & phrasal verbs",              path: "/admin/content/phrases",             icon: "💬" },
  { label: "Homonyms",             desc: "Words with multiple meanings",                 path: "/admin/content/homonyms",            icon: "🔁" },
  { label: "Reading Passages",     desc: "Comprehension passages",                       path: "/admin/content/reading",             icon: "📰" },
];

const ContentHubPage = () => {
  const navigate = useNavigate();

  return (
    <AdminPageLayout
      title="Content Hub"
      subtitle="Manage all learning content available to users in the app."
      instruction="Each section below manages a specific type of learning content. Click a card to open that section. Changes are reflected in the app immediately after saving."
    >
      <div className="content-grid">
        {CONTENT_ITEMS.map((item) => (
          <div key={item.path} className="content-card" onClick={() => navigate(item.path)}>
            <div style={{ fontSize: "1.75rem", marginBottom: 8 }}>{item.icon}</div>
            <h3>{item.label}</h3>
            <p style={{ margin: 0, fontSize: "0.85rem", color: "#64748b" }}>{item.desc}</p>
          </div>
        ))}
      </div>
    </AdminPageLayout>
  );
};

export default ContentHubPage;
